import { AlertTriangle } from 'lucide-react'
import { cn } from '@utils/cn'

export function ForbiddenPage() {
  return (
    <div 
      data-forbidden-page="true"
      className={cn(
        "flex items-center justify-center min-h-[calc(100vh-200px)]",
        "bg-gray-50 dark:bg-gray-900"
      )}
    >
      <div className="text-center p-8">
        <AlertTriangle className="w-16 h-16 text-red-500 mx-auto mb-4" />
        <h1 className="text-2xl font-bold text-gray-900 dark:text-white mb-2">
          Acesso Proibido
        </h1>
        <p className="text-gray-600 dark:text-gray-400">
          Você não tem permissão para acessar esta página.
        </p>
        <p className="text-sm text-gray-500 dark:text-gray-500 mt-2">
          Entre em contato com o administrador se acredita que isso é um erro.
        </p>
      </div>
    </div>
  )
}
